import React from 'react';
import { motion } from 'framer-motion';
import { getCheckoutUrl } from '../utils/getCheckoutUrl';
import { trackAddToCart } from '../utils/metaPixel';
interface HeaderProps {
  addedBumps: Record<string, boolean>;
}
export function Header({
  addedBumps
}: HeaderProps) {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-dark-bg/95 backdrop-blur-sm border-b border-dark-secondary" data-id="element-34">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-35">
        <h1 className="text-lg md:text-xl font-serif font-bold text-text-primary" data-id="element-36">
          No sabes cómo empezar
        </h1>
        <a href={getCheckoutUrl(addedBumps)} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="px-4 py-2 md:px-6 md:py-2.5 bg-accent text-dark-bg font-semibold rounded-lg hover:bg-accent/90 transition-colors text-sm md:text-base inline-block" data-id="element-37">
          Empezar ahora
        </a>
      </div>
    </motion.header>;
}